import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/scale_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-17f1cd98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "Vehicle container",
  id: "monitor_page"
}
const _hoisted_2 = { class: "vehicle-info" }
const _hoisted_3 = { class: "left width80" }
const _hoisted_4 = { class: "right width20" }
const _hoisted_5 = { class: "ReStart-Item" }
const _hoisted_6 = { class: "Log-Item" }
const _hoisted_7 = { class: "vehicle-supply" }
const _hoisted_8 = { class: "scale-div" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "control-elements" }
const _hoisted_11 = { class: "task-information" }
const _hoisted_12 = { class: "task-info-div" }
const _hoisted_13 = { class: "schema-details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_BasicInfo = _resolveComponent("BasicInfo")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ReStart = _resolveComponent("ReStart")!
  const _component_LogBags = _resolveComponent("LogBags")!
  const _component_Supply = _resolveComponent("Supply")!
  const _component_SnapRecordList = _resolveComponent("SnapRecordList")!
  const _component_controlMapElements = _resolveComponent("controlMapElements")!
  const _component_TaskInformation = _resolveComponent("TaskInformation")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_SchemaDetails = _resolveComponent("SchemaDetails")!
  const _component_MapView = _resolveComponent("MapView")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("operater")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: `${_ctx.routerName.unattendedList}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("unattended")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("unattendedcontrol")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_BasicInfo, {
            vin: _ctx.carVin,
            mapName: _ctx.mapName,
            floorName: _ctx.floorName,
            locationFail: _ctx.cleanTaskRfidPoint?.xg || _ctx.cleanTaskRfidPoint?.yg
          }, null, 8, ["vin", "mapName", "floorName", "locationFail"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ErrorMessage, { vin: _ctx.carVin }, null, 8, ["vin"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ReStart, { vin: _ctx.carVin }, null, 8, ["vin"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_LogBags, { vin: _ctx.carVin }, null, 8, ["vin"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Supply, { supply_task_status: _ctx.supplyTaskStatus }, null, 8, ["supply_task_status"])
      ], 512), [
        [_vShow, 
        _ctx.supplyTaskStatus?.task_status == _ctx.ConstantsType.supply_status_ing_1
      ]
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_SnapRecordList, {
          vin: _ctx.carVin,
          ref: "SnapRecordListRef"
        }, null, 8, ["vin"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.scaleValue) + _toDisplayString(_ctx.t("metre")) + " ", 1),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_controlMapElements, {
          onToggleVirtualWalls: _ctx.toggleVirtualWallsMethod,
          onToggleFunctionAreas: _ctx.toggleFunctionAreasMethod,
          onToggleFunctionpoints: _ctx.toggleFunctionpointsMethod
        }, null, 8, ["onToggleVirtualWalls", "onToggleFunctionAreas", "onToggleFunctionpoints"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_TaskInformation, {
          floorTaskStatus: _ctx.floorTaskStatus,
          onListenMapId: _ctx.floorClickMap
        }, null, 8, ["floorTaskStatus", "onListenMapId"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.supplyTaskTatus
                ? _ctx.supplyTaskTatus
                : _ctx.returnTaskStatus
                ? _ctx.returnTaskStatus
                : _ctx.taskName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.supplyTaskTatus || _ctx.returnTaskStatus ? "" : _ctx.cleanModeName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 4 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.supplyTaskTatus || _ctx.returnTaskStatus ? "" : _ctx.taskProgress), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 10 }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.supplyTaskTatus || _ctx.returnTaskStatus ? "" : _ctx.startTime), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, 
        _ctx.cleanTaskStatus == _ctx.ConstantsType.task_status_ing_1 ||
        _ctx.cleanTaskStatus == _ctx.ConstantsType.task_status_pause_3 ||
        _ctx.supplyTaskTatus ||
        _ctx.returnTaskStatus ||
        _ctx.floorTaskStatus?.run_state == _ctx.ConstantsType.floor_task_status_ing_1 ||
        _ctx.floorTaskStatus?.run_state == _ctx.ConstantsType.floor_task_status_pause_4
      ]
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_SchemaDetails, { vin: _ctx.carVin }, null, 8, ["vin"])
      ]),
      _createElementVNode("p", {
        class: "change-sleep-time",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInputDialog = true))
      }, _toDisplayString(_ctx.t("changesleeptime")), 1),
      _createVNode(_component_MapView, {
        class: "map-view-class",
        vin: _ctx.carVin,
        mapId: _ctx.floorSelectMapId,
        showMapVirtualWalls: _ctx.showvirtualwall,
        showFunctionAreas: _ctx.showfunctionAreas,
        showFunctionPoints: _ctx.showfunctionpoints,
        onListenScale: _ctx.getScale,
        onListenMapname: _ctx.getMapName,
        onListenFloorname: _ctx.getFloorName,
        onListenTask: _ctx.listenTaskIngInfo
      }, null, 8, ["vin", "mapId", "showMapVirtualWalls", "showFunctionAreas", "showFunctionPoints", "onListenScale", "onListenMapname", "onListenFloorname", "onListenTask"])
    ]),
    _createVNode(_component_a_modal, {
      open: _ctx.showInputDialog,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showInputDialog) = $event)),
      title: _ctx.t('changesleeptime'),
      onOk: _ctx.submitSleepTime,
      center: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: _ctx.sleepTime,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sleepTime) = $event)),
          type: "number",
          placeholder: _ctx.t('changesleeptime')
        }, null, 8, ["value", "placeholder"])
      ]),
      _: 1
    }, 8, ["open", "title", "onOk"])
  ], 64))
}